// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"search-input_searchBar__Bex41"};